module.exports = __webpack_public_path__ + "static/media/table-sort.6b0cd139.svg";